import React, { useEffect, useState } from 'react';
import './index.css';

const NewHome: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <div className="app">
            <div className="ambient" aria-hidden="true">
                <span className="blob blob-a" />
                <span className="blob blob-b" />
            </div>

            <main className={`content ${isVisible ? 'visible' : ''}`}>
                <p className="name">Mmetja Kekana</p>
                <p className="role">Software Factotum</p>

                <div className="links">
                    <a href="https://unit326.com" target="_blank" rel="noopener noreferrer">
                        Unit 326
                    </a>
                    <a href="https://medium.com/@mmetjakekana" target="_blank" rel="noopener noreferrer">
                        Writing
                    </a>
                    <a href="https://github.com/mmetja" target="_blank" rel="noopener noreferrer">
                        GitHub
                    </a>
                    <a href="https://www.linkedin.com/in/mmetja-kekana-95801a150/" target="_blank" rel="noopener noreferrer">
                        LinkedIn
                    </a>
                    <a href="https://twitter.com/mmetjakekana" target="_blank" rel="noopener noreferrer">
                        Twitter
                    </a>
                </div>
            </main>

            <footer>
                <p>&copy; {new Date().getFullYear()}</p>
            </footer>
        </div>
    );
};

export default NewHome;
